<script>
import
{
    Line
}
from 'vue-chartjs'
import moment from 'moment'

export default
{
    extends: Line,
    props: ['height', 'tempData', 'label', 'field', 'showDetails'],
    data()
    {
        var me = this;
        return {
            datasets:
            [
                {
                    label: me.label,
                    backgroundColor: 'rgba(54, 169, 225, 0.55)',
                    borderColor: 'rgb(54, 169, 225)',
                    data: []
                }
            ],
            labels: []
        }
    },
    mounted()
    {
        var me = this;

        me.calcTemp();

        this.renderChart(
        {
            labels: me.labels,
            datasets: me.datasets
        },
        {
            maintainAspectRatio: false,
            animation: {
                onComplete: function(animation)
                {
                    if(!me.showDetails) return;
                    var chartInstance = this.chart,
                    ctx = chartInstance.ctx;

                    ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'bottom';

                    me.datasets.forEach(function(dataset, i)
                    {
                        var meta = chartInstance.controller.getDatasetMeta(i);
                        meta.data.forEach(function(bar, index)
                        {
                            var data = dataset.data[index];
                            ctx.fillText(data, bar._model.x, bar._model.y - 5);
                        });
                    });
                }
            },
            legend:
            {
                display: (me.showDetails) ? true : false,
                position: "bottom"
            },
            scales:
            {
                yAxes: [
                {
                    display: (me.showDetails) ? true : false,
                    ticks:
                    {
                        display: (me.showDetails) ? true : false,
                        min: 0, //.min.apply(Math, me.datasets[0].data) - 5,
                        //max: Math.max.apply(Math, me.datasets[0].data) + 5
                    }
                }]
            },
            elements:
            {
                line:
                {
                    borderWidth: 1
                },
                point:
                {
                    radius: 4,
                    hitRadius: 10,
                    hoverRadius: 4
                }
            }
        })
    },
    methods:
    {
        calcTemp()
        {
            var me = this;

            me.labels = [];

            var newTempData = me.tempData.slice();

            newTempData.reverse();

            var data = [];
            for(var item of newTempData)
            {
                data.push(item[me.field]);
                me.labels.push(moment.utc(item.dateTime).local().format('HH:mm'));
            }
            
            me.$set(me.datasets[0], 'data', data);
        }
    },
    watch:
    {
        tempData()
        {
            var me = this;
            me.calcTemp();
        }
    }
}
</script>
